angular.module('todo')
    .directive('todoStatusPicker', function (TodoService) {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                required: "=",
                modelType: '=',
                onChange: "&",
                initialValue: "=?"
            },
            templateUrl: "app/todo/status-picker.html",
            link: function (scope, $element, $attrs, ngModelCtrl) {
                scope.executeOnChange = scope.onChange || angular.noop
                scope.modelTypeR = scope.modelType || "object"

                scope.items = TodoService.statuses()
                if(scope.initialValue != null && typeof scope.initialValue === "string"){
                    scope.selected = scope.items.find(i => i.name === scope.initialValue)
                    scope.onSelectionChanged(scope.selected, scope.selected)
                }

                ngModelCtrl.$render = () => scope.selected = ngModelCtrl.$viewValue
                ngModelCtrl.$formatters.push(modelValue => modelValue)
                ngModelCtrl.$parsers.push(viewValue => scope.modelTypeR === "id" ? viewValue.id : viewValue)

                scope.onSelectionChanged = ($item, $model) => {
                    ngModelCtrl.$setViewValue($item)
                    ngModelCtrl.$validate()
                    ngModelCtrl.$render()
                    if(angular.isFunction(scope.executeOnChange())){
                        scope.executeOnChange()($item)
                    }
                }
            }
        }
    })
